import React from 'react';
import AdvertisementUploadContainer from 'containers/AdvertisementUploadContainer';

export default function AdvertisementUploadPage() {
  return <AdvertisementUploadContainer />;
}
